// Staging environment configuration

export interface Environment {
  graphqlEndpoint: string;
  environment: string;
  posthogKey: string;
  posthogHost: string;
  posthogEnabled: boolean;
  // Base URL the desktop app downloads Cowork skills from (frontend origin).
  skillsBaseUrl: string;
}

export const environment: Environment = {
  graphqlEndpoint: process.env.STAGE_GRAPHQL_ENDPOINT || 'https://stage.gk.ignosistech.in/v1/graphql',
  environment: 'staging',
  posthogKey: 'phc_kOberlZkPR91VRjmsa4p7Opk9xyvpDAb1OnTeOtACxS',
  posthogHost: 'https://stage.gk.ignosistech.in/ingest',
  posthogEnabled: true,
  skillsBaseUrl: process.env.STAGE_SKILLS_BASE_URL || 'https://stage.gk.ignosistech.in',
};
